import { Box, HStack, Spinner, Text } from "@chakra-ui/react"

interface PreparingNextCardProps {
  borderColor: string
  mutedText: string
}

export function PreparingNextCard({
  borderColor,
  mutedText,
}: PreparingNextCardProps) {
  return (
    <Box
      borderWidth={1}
      borderColor={borderColor}
      borderRadius="2xl"
      p={8}
      minH="220px"
      display="grid"
      placeItems="center"
      textAlign="center"
    >
      <HStack gap={3}>
        <Spinner size="sm" color="teal.500" />
        <Box textAlign="left">
          <Text fontWeight="bold">Preparing next card...</Text>
          <Text fontSize="sm" color={mutedText}>
            Saving your score and finalizing the next prompt.
          </Text>
        </Box>
      </HStack>
    </Box>
  )
}
